import Axios from 'axios'
import { GraphQLStoreFrontJWT } from '@/services/Configuration'
import { error } from '@/services/Log'

const GraphQLHeaders = (headers: object = {}) => ({
  headers: {
    ...headers,
    'Content-Type': 'application/json',
    Authorization: `Bearer ${GraphQLStoreFrontJWT}`,
  },
})

export const signUserIn = async ({ email, password }) => {
  let success = false
  try {
    const response = await Axios.post(
      '/graphql',
      {
        query: `mutation Login($email: String!, $password: String!) {
                        login(email: $email, password: $password) {
                          result
                        }
                      }
                      `,
        variables: { email, password },
      },
      GraphQLHeaders(),
    )
    success = response?.data?.data?.login?.result === 'success'
  } catch (err) {
    error(`Failed to login via GRAPHQL ${err}`)
  }
  return { success }
}

export const signUserOut = async () => {
  let success = false
  try {
    const response = await Axios.post(
      '/graphql',
      {
        query: `mutation logout {
          logout {
            result
          }
        }`,
      },
      GraphQLHeaders(),
    )
    success = response?.data?.data?.logout?.result === 'success'
    return { success }
  } catch {
    return { success }
  }
}

export type GraphQlCustomer = {
  entityId: number,
  company: string,
  customerGroupId: number,
  email: string
  firstName: string
  lastName: string,
  notes: string,
  phone: string
  taxExemptCategory: string
  addressCount: number
  attributeCount: number
}
type AxiosGraphQLGetCustomer = {
  data: {
    customer: null | GraphQlCustomer
  }
}
type GraphQLGetCustomerRequest = (p?: { pathPrefix?: string, headers?: object }) => Promise<{ success: true, customer: GraphQlCustomer } | { success: false, customer: null }>
export const getCustomer: GraphQLGetCustomerRequest = async ({ pathPrefix = '', headers = {} } = {}) => {
  try {
    const { data } = await Axios.post<AxiosGraphQLGetCustomer>(
      `${pathPrefix}/graphql`,
      {
        query: `query customer {
          customer {
            entityId
            company
            customerGroupId
            email
            firstName
            lastName
            notes
            phone
            taxExemptCategory
            addressCount
            attributeCount
          }
        }`,
      },
      GraphQLHeaders(headers),
    )
    const customer = data?.data?.customer
    if (customer) {
      return { success: true, customer }
    }
  } catch {
  }
  return { success: false, customer: null }
}
